import React, { useState, useEffect } from 'react';
import axios from "axios";
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';

import 'react-toastify/dist/ReactToastify.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer } from 'react-toastify';
import { BiSolidShow } from "react-icons/bi";
import { FaLock, FaLockOpen } from "react-icons/fa";
import { FiEdit, } from "react-icons/fi"; // אייקוני עריכה והוספה

import './Home.css';
import Contact from '../Contact/Contact';
import Leagues from '../Leagues/Leagues';
import TeamsManager from "../TeamsManager/TeamsManager";
import Halls from "../Halls/Halls";
import AddLeague from "../Leagues/AddLeague";
import EditLeague from "../Leagues/EditLeague";
import Layout from '../Layout/Layout';
import Tournaments from '../Tournaments/Tournaments';
import TournamentDetails from "../Tournaments/TournamentDetails";
import AdminPanel from '../AdminPanel/AdminPanel';
import Regulations from '../Regulations/Regulations';
import AddRegulation from '../Regulations/AddRegulation';
import EditRegulation from '../Regulations/EditRegulation';
// import EilatTournaments from '../EilatTournaments/EilatTournaments';
// import AddEventForm from '../Tournaments/AddEventForm';
// import EditDailyTournament from '../DailyTournaments/EditDailyTournament';
// import DailyTournaments from '../DailyTournaments/DailyTournaments';
import AddTournament from '../Tournaments/AddTournament';
import EditTournament from '../Tournaments/EditTournament';
// import EilatTournamentForm from '../EilatTournaments/EilatTournamentForm';

import { useAuth } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { AuthProvider } from '../../Context/AuthContext';

import Login from "../../Pages/Login/Login";
import Profile from "../../Pages/Profile/Profile";
import AdminUsers from "./../../Pages/AdminUsers/AdminUsers";
import HeaderIcons from '../HeaderIcons/HeaderIcons';
import ImageSlider from '../ImageSlider/ImageSlider';

import VisitStats from '../VisitStats/VisitStats';
import PageBackground from "../PageBackground/PageBackground";
import EventForm from '../Tournaments/EventForm';
import AddEilatYear from '../Tournaments/AddEilatYear';

const API = process.env.REACT_APP_API || window.location.origin;

function HomePage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [showLeagues, setShowLeagues] = useState(true);
  const [leaguesClickable, setLeaguesClickable] = useState(true);
  const [showTournaments, setShowTournaments] = useState(true);
  const [tournamentsClickable, setTournamentsClickable] = useState(true);
  const [showRules, setShowRules] = useState(true);
  const [showRegulations, setShowRegulations] = useState(true);
  const [sliderImages, setSliderImages] = useState([]);
  const [files, setFiles] = useState([]);
  const [loadingFiles, setLoadingFiles] = useState(true);

  const MySwal = withReactContent(Swal);

  useEffect(() => {
    axios.get(`${API}/api/backgrounds/home`)
      .then(res => {
        const urls = res.data.map(img => img.url);
        setSliderImages(urls);
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    axios
      .get("/api/regulations")
      .then((res) => setFiles(res.data))
      .catch((err) => console.error("שגיאה בטעינת קבצים:", err))
      .finally(() => setLoadingFiles(false));
  }, []);


  // 🔹 טעינת הערכים מה-DB בהתחלה
  useEffect(() => {
    axios.get(`${API}/api/admin/settings/get`)
      .then(res => {
        const s = res.data;
        setShowLeagues(s.showLeagues);
        setLeaguesClickable(s.leaguesClickable);
        setShowTournaments(s.showTournaments);
        setTournamentsClickable(s.tournamentsClickable);
        setShowRules(s.showRules);
        setShowRegulations(s.showRegulations);
      })
      .catch(console.error);

    // ספירת ביקורים
    axios.post(`${API}/api/visits/increment`).catch(console.error);
  }, []);

  // 🔹 פונקציה לעדכון ערך ב-DB
  const updateSetting = (key, value, setter) => {
    setter(value);
    axios.post(`${API}/api/admin/settings/update`, { key, value })
      .catch(console.error);
  };

  return (
    <div className="container">
      {/*Regulations*/}
      <div className="pdf-container">
        {!loadingFiles && files.length === 0 ? (
          <p className="no-files-message">אין קבצים להצגה</p>
        ) : (
          files
            .filter(file => {
              if (file.title.includes("חוקה")) return showRules || user?.isAdmin;
              if (file.title.includes("תקנון")) return showRegulations || user?.isAdmin;
              return true;
            })
            .map(file => (
              <div key={file._id}>
                <button key={file._id}
                  onClick={() => window.open(file.filePath, "_blank")}
                  className="pdf-btn"
                >
                  {file.title}
                  {user?.isAdmin && (
                    <>
                      <FiEdit
                        className="edit-icon"
                        size={18}
                        title={"עריכה"}
                        onClick={(e) => { e.stopPropagation(); navigate(`/regulations/edit/${file._id}`); }}
                      // onClick={() => navigate(`/regulations/edit/${file._id}`)}
                      />

                      <div>
                        {user?.isAdmin && (
                          <div className="inside-checkboxes">
                            {file.title.includes("חוקה") && (
                              <BiSolidShow
                                onClick={(e) => {
                                e.stopPropagation();
                                MySwal.fire({
                                  title: showRules ? "הסתרת כפתור החוקה" : "הצגת כפתור החוקה",
                                  text: showRules
                                    ? "אתה בטוח שברצונך להסתיר את כפתור החוקה מהאתר?"
                                    : "להציג את כפתור החוקה באתר?",
                                  icon: "question",
                                  showCancelButton: true,
                                  confirmButtonText: "כן",
                                  cancelButtonText: "ביטול",
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    updateSetting("showRules", !showRules, setShowRules);
                                  }
                                });
                              }}
                              style={{
                                cursor: "pointer",
                                color: showRules ? "green" : "red",
                                transform: showRules ? "scale(1.2)" : "scale(1)",
                                transition: "color 0.3s, transform 0.2s"
                              }}
                              title={showRules ? "מוצג באתר" : "מוסתר באתר"}
                              size={25}
                            />
                            )}

                            {file.title.includes("תקנון") && (
                              <BiSolidShow
                                onClick={(e) => {
                                e.stopPropagation();
                                MySwal.fire({
                                  title: showRegulations ? "הסתרת כפתור התקנון" : "הצגת כפתור התקנון",
                                  text: showRegulations
                                    ? "אתה בטוח שברצונך להסתיר את כפתור התקנון מהאתר?"
                                    : "להציג את כפתור התקנון באתר?",
                                  icon: "question",
                                  showCancelButton: true,
                                  confirmButtonText: "כן",
                                  cancelButtonText: "ביטול",
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    updateSetting("showRegulations", !showRegulations, setShowRegulations);
                                  }
                                });
                              }}
                              style={{
                                cursor: "pointer",
                                color: showRegulations ? "green" : "red",
                                transform: showRegulations ? "scale(1.2)" : "scale(1)",
                                transition: "color 0.3s, transform 0.2s"
                              }}
                              title={showRegulations ? "מוצג באתר" : "מוסתר באתר"}
                              size={25}
                            />
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </button>
              </div>
            ))
        )}
      </div>

      {/* Navigation */}
      <nav className="nav-buttons">
        {user?.isAdmin && (
          <Link to="/admin" className="upload-CSV">CSV ותמ' רקע</Link>
        )}

        {/* 🔹 ליגות */}
        {(showLeagues || user?.isAdmin) && (
          <div className="nav-link-wrapper">
            <Link
              to={leaguesClickable ? "/leagues" : "#"}
              onClick={(e) => !leaguesClickable && e.preventDefault()}
              style={{
                color: showLeagues ? (leaguesClickable ? "black" : "gray") : "#aaa",
                opacity: showLeagues || user?.isAdmin ? 1 : 0.4,
                cursor: leaguesClickable ? "pointer" : "not-allowed",
              }}
              className="nav-link"
            >
              ליגות
            </Link>

            {user?.isAdmin && (
              <div className="inside-checkboxes">
                <BiSolidShow
                  onClick={() => {
                    MySwal.fire({
                      title: showLeagues ? "הסתרת כפתור הליגות" : "הצגת כפתור הליגות",
                      text: showLeagues
                        ? "אתה בטוח שברצונך להסתיר את כפתור הליגות מהאתר?"
                        : "להציג את כפתור הליגות באתר?",
                      icon: "question",
                      showCancelButton: true,
                      confirmButtonText: "כן",
                      cancelButtonText: "ביטול",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        updateSetting("showLeagues", !showLeagues, setShowLeagues);
                      }
                    });
                  }}
                  style={{
                    cursor: "pointer",
                    color: showLeagues ? "green" : "red",
                    transform: showLeagues ? "scale(1.2)" : "scale(1)",
                    transition: "color 0.3s, transform 0.2s"
                  }}
                  title={showLeagues ? "מוצג באתר" : "מוסתר באתר"}
                  size={25}
                />
                {leaguesClickable ? (
                  <FaLockOpen
                    onClick={() => {
                      MySwal.fire({
                        title: "נעילת כפתור הליגות",
                        text: "לנעול את כפתור הליגות?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "כן, לנעול",
                        cancelButtonText: "ביטול",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          updateSetting("leaguesClickable", !leaguesClickable, setLeaguesClickable);
                        }
                      });
                    }}
                    style={{
                      cursor: "pointer",
                      color: "green",
                      transform: "scale(1.2)",
                      transition: "color 0.3s, transform 0.2s"
                    }}
                    title="מופעל"
                    size={22}
                  />
                ) : (
                  <FaLock
                    onClick={() => {
                      MySwal.fire({
                        title: "הפעלת כפתור הליגות",
                        text: "להפעיל מחדש את כפתור הליגות?",
                        icon: "info",
                        showCancelButton: true,
                        confirmButtonText: "כן, להפעיל",
                        cancelButtonText: "ביטול",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          updateSetting("leaguesClickable", !leaguesClickable, setLeaguesClickable);
                        }
                      });
                    }}
                    style={{
                      cursor: "pointer",
                      color: "red",
                      transform: "scale(1)",
                      transition: "color 0.3s, transform 0.2s"
                    }}
                    title="נעול"
                    size={22}
                  />
                )}
              </div>
            )}
          </div>
        )}

        {/* 🔹 טורנירים */}
        {(showTournaments || user?.isAdmin) && (
          <div className="nav-link-wrapper">
            <Link
              to={tournamentsClickable ? "/tournaments" : "#"}
              onClick={(e) => !tournamentsClickable && e.preventDefault()}
              style={{
                color: showTournaments ? (tournamentsClickable ? "black" : "gray") : "#aaa",
                opacity: showTournaments || user?.isAdmin ? 1 : 0.4,
                cursor: tournamentsClickable ? "pointer" : "not-allowed",
              }}
              className="nav-link"
              title='לא נגיש כרגע'
            >
              טורנירים ואירועים
            </Link>

            {user?.isAdmin && (
              <div className="inside-checkboxes">
                <BiSolidShow
                  onClick={() => {
                    Swal.fire({
                      title: showTournaments
                        ? "אתה בטוח שברצונך להסתיר את כפתור הטורנירים מהאתר?"
                        : "להציג את כפתור הטורנירים באתר?",
                      icon: "question",
                      showCancelButton: true,
                      confirmButtonText: "כן",
                      cancelButtonText: "ביטול",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        updateSetting("showTournaments", !showTournaments, setShowTournaments);
                      }
                    });
                  }}
                  style={{
                    cursor: "pointer",
                    color: showTournaments ? "green" : "red",
                    transform: showTournaments ? "scale(1.2)" : "scale(1)",
                    transition: "color 0.3s, transform 0.2s"
                  }}
                  title={showTournaments ? "מוצג באתר" : "מוסתר באתר"}
                  size={25}
                />
                {tournamentsClickable ? (
                  <FaLockOpen
                    onClick={() => {
                      Swal.fire({
                        title: "לנעול את כפתור הטורנירים?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "כן",
                        cancelButtonText: "ביטול",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          updateSetting("tournamentsClickable", !tournamentsClickable, setTournamentsClickable);
                        }
                      });
                    }}
                    style={{
                      cursor: "pointer",
                      color: "green",
                      transform: "scale(1.2)",
                      transition: "color 0.3s, transform 0.2s"
                    }}
                    title="מופעל"
                    size={22}
                  />
                ) : (
                  <FaLock
                    onClick={() => {
                      Swal.fire({
                        title: "להפעיל מחדש את כפתור הטורנירים?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "כן",
                        cancelButtonText: "ביטול",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          updateSetting("tournamentsClickable", !tournamentsClickable, setTournamentsClickable);
                        }
                      });
                    }}
                    style={{
                      cursor: "pointer",
                      color: "red",
                      transform: "scale(1)",
                      transition: "color 0.3s, transform 0.2s"
                    }}
                    title="נעול"
                    size={22}
                  />
                )}
              </div>
            )}
          </div>
        )}

        {/* <Link to="/open-net">רשת פתוחה</Link> */}
      </nav>

      {/* אייקונים בפינה הימנית העליונה */}
      <HeaderIcons />
      <br />

      {/* הודעה למשתמשים */}
      {/* <div className='message'>
        <p><strong>האתר אינו פעיל זמנית, לפרטים ניתן לפנות לרכז הליגות</strong></p>
      </div> */}


      {/* Image Slider */}
      <div className='images'>
        <ImageSlider images={sliderImages} interval={4000} /> {/* 5 שניות */}
      </div>

    </div>
  );
}

// עוטף כדי לקרוא את slug מה-URL
// const TournamentDetailsWrapper = () => {
//   const { slug } = useParams();
//   return <TournamentDetails slug={slug} />;
// };

// 🟢 כל הנתיבים (Routes)
function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />

        {/* עמודי אדמין בלבד */}
        {user?.isAdmin && (
          <>
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/stats" element={<VisitStats />} />
          </>
        )}

        {/* עמודי פומביים */}
        <Route path="/login" element={<Login />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/leagues" element={<Leagues />} />
        <Route path="/leagues/new" element={<AddLeague />} />
        <Route path="/leagues/edit/:id" element={<EditLeague />} />
        <Route path="/teams" element={<TeamsManager />} />
        <Route path="/halls" element={<Halls />} />
        <Route path="/tournaments" element={<Tournaments />} />
        <Route path="/tournaments/new" element={<AddTournament />} />
        <Route path="/tournaments/edit/:id" element={<EditTournament />} />
        <Route path="/tournaments/:slug" element={<TournamentDetails />} />
        <Route path="/tournaments/:slug/events/new" element={<EventForm mode="create" />} />
        <Route path="/tournaments/:slug/events/:eventId/edit" element={<EventForm mode="edit" />} />
        <Route path="/tournaments/:slug/eilat/new-year" element={<AddEilatYear />} />


        {/* <Route path="/tournaments/:slug/new" element={<AddEventForm />} /> */}
        {/* <Route path="/tournaments/:slug/edit-event/:eventId" element={<EditTournament />} /> */}
        {/* <Route path="/tournaments/:slug" element={<TournamentDetailsWrapper />} /> */}
        {/* <Route path="/dailyTournaments" element={<DailyTournaments />} /> */}
        {/* <Route path="/dailyTournaments/new" element={<AddEventForm />} /> */}
        {/* <Route path="/dailyTournaments/edit/:id" element={<EditDailyTournament />} /> */}
        {/* <Route path="/eilatTournaments" element={<EilatTournaments />} />
        <Route path="/eilatTournaments/new" element={<EilatTournamentForm mode="add"/>} />
        <Route path="/eilatTournaments/edit/:id" element={<EilatTournamentForm mode="edit"/>} /> */}
        <Route path="/regulations" element={<Regulations />} />
        <Route path="/regulations/new" element={<AddRegulation />} />
        <Route path="/regulations/edit/:id" element={<EditRegulation />} />
        <Route path="/contact" element={<Contact />} />

        {/* 404 */}
        <Route path="*" element={<h1>עמוד לא נמצא</h1>} />
      </Route>
    </Routes>
  );
}


function Home() {
  return (
    <AuthProvider>
      <Router>
        <PageBackground />

        <ToastContainer position="top-center" autoClose={3000} />
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default Home;